(ns teamoesterreich.util.markdown)

(def md
  (try
    (.. (js/markdownit #js{:html    true
                           :breaks  true
                           :linkify true})
        (use js/markdownitMark)
        (use js/markdownitEmoji)
        ;(use js/markdownitFootnote)
        )
    (catch :default _
      #js{:render      str
          :parse       str
          :parseInline str})))
